<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/orders/buddleOrder' }">同捆订单列表</el-breadcrumb-item>
          <el-breadcrumb-item>同捆列表详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">订单编号:</div>
            <div class="flex1">
              <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.orderId"
                  size="small"
                  @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">国内运单号:</div>
            <div class="flex1">
              <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.trackingNumberCn"
                  size="small"
                  @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">订单状态:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.orderStatus" placeholder="请选择" size="small" clearable>
                <el-option
                    v-for="item in orderStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">下单开始日:</div>
            <div class="flex1">
              <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeStart"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">下单结束日:</div>
            <div class="flex1">
              <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeEnd"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">发送开始日:</div>
            <div class="flex1">
              <el-date-picker
                  clearable
                  v-model="queryInfo.sendTimeStart"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">发送结束日:</div>
            <div class="flex1">
              <el-date-picker
                  clearable
                  v-model="queryInfo.sendTimeEnd"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="search-btn-container" style="text-align:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
            </div>
          </el-col>
        </el-row>
              <div class="bill_top">
                <span class="tk-title">用户：<i>{{tkPackageInfo.userName}}</i></span>
                <span class="tk-title">同捆编号：<i>{{tkPackageInfo.tongkunNo}}</i></span>
                <span class="tk-title">箱子类型：<i>{{tkPackageInfo.cartonSize}}</i></span>
                <span class="tk-title">实重：<i>{{tkPackageInfo.realWeight}}</i></span>
                <span class="tk-title">抛重：<i>{{tkPackageInfo.throwWeight}}</i></span>
                <span class="tk-title">OPP袋类型：<i>{{tkPackageInfo.oppType}}</i></span>
                <span class="tk-title">OPP袋数：<i>{{tkPackageInfo.oppCount}}</i></span>
              </div>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
            :data="recordList"
            border
            style="width: 100%"
            height="550"
            :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle"
        >
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column label="订单操作" align="center" width="80">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button
                    class="list-btn btn-blue"
                    @click="toOrderDetail(scope.row)"
                >
                  详情
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="id" align="center" label="订单编号"></el-table-column>
          <el-table-column prop="orderStatus" align="center" label="订单状态" width="80">
            <template v-slot="scope">
              {{ orderStatusShow(scope.row.orderStatus) }}
            </template>
          </el-table-column>
          <el-table-column prop="trackingNumberJpn" width="120" label="国际运单号"></el-table-column>
          <el-table-column label="图片" align="center" width="115">
            <template slot-scope="scope">
              <img v-if="scope.row.pictureUrl&&scope.row.pictureUrl.length>0" :src="scope.row.pictureUrl" alt=""
                   class="list-image">
              <img v-else src="../../../assets/images/default.png" alt="" class="list-image">
            </template>
          </el-table-column>
          <el-table-column prop="createTime"  align="center" label="下单日" min-width="100">
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToDay }}
            </template>
          </el-table-column>
          <el-table-column prop="receiveTime" align="center" label="到库日" min-width="100">
            <template v-slot="scope">
              {{ scope.row.receiveTime | dateFormatToDay }}
            </template>
          </el-table-column>
          <el-table-column prop="sendTime" align="center" label="发送日" min-width="100">
            <template v-slot="scope">
              {{ scope.row.sendTime | dateFormatToDay }}
            </template>
          </el-table-column>
          <el-table-column prop="trackingNumberCn" label="国内运单号" min-width="120"></el-table-column>
          <el-table-column prop="goodsName" label="商品名称" min-width="150"></el-table-column>
          <el-table-column prop="taobaoUrl" label="商品URL" min-width="200"></el-table-column>
          <el-table-column prop="price" align="center" label="价格"></el-table-column>
          <el-table-column prop="goodsCount" align="center" label="数量"></el-table-column>
          <el-table-column prop="colour" align="center" label="颜色"></el-table-column>
          <el-table-column prop="goodsSize" align="center" label="尺码"></el-table-column>
          <el-table-column prop="customerRemark" label="备注"></el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from '../../../views/tableContainer'

export default {
  components: {tableCon},
  data() {
    return {
      queryInfo: {
        id: '',
        orderId: '',
        trackingNumberCn: '',
        orderStatus: '',
        createTimeStart: '',
        createTimeEnd: '',
        sendTimeStart: '',
        sendTimeEnd: '',
        pageSize: 10,
        pageNum: 1,
      },
      // orderDateRangeValue:[],
      // shipDateRangeValue:[],
      orderStatusOptions: [],
      recordList: [],
      tkPackageInfo:{
        userId:'',
        userName:'',
        tongkunNo:'',
        throwWeight:'',
        realWeight:'',
        cartonSizeId:'',
        cartonSize:'',
        oppTypeId:'',
        oppType:'',
        oppCount:'',
      },
      splitDialogVisible: false,
      orginSplitOrderInfo: {},
      splitOrderInfo: {},
      splitForm: {},
      total: 0
    }
  },
  methods: {
    orderStatusShow(status) {
      switch (status) {
        case '0':
          return '等待到库'
          break;
           case '1':
        return '待购买'
        break;
         case '2':
        return '购买完'
        break;
        case '4':
          return '到库'
          break;
        case '8':
          return '检品中'
          break;
        case '12':
          return '检品完'
          break;
        case '16':
          return '仓库保管中'
          break;
        case '20':
          return '申请发货'
          break;
        case '24':
          return '不良待处理'
          break;
        case '28':
          return '换货待发回'
          break;
        case '32':
          return '换货等待到货'
          break;
        case '36':
          return '待部分退货'
          break;
        case '40':
          return '补发等待到货'
          break;
        case '44':
          return '待支付'
          break;
        case '48':
          return '待发送'
          break;
        case '52':
          return '已发送'
          break;
        case '56':
          return '已取消'
          break;
        case '60':
          return '退货申请中'
          break;
        case '64':
          return '退货待支付'
          break;
        case '68':
          return '待退货'
          break;
        case '72':
          return '已退货'
          break;
        case '76':
          return '销毁申请中'
          break;
        case '80':
          return '销毁待支付'
          break;
        case '84':
          return '已销毁'
          break;
        case '88':
          return '装箱中'
          break;
      }
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    orderDateRange() {

    },
    shipDateRange() {

    },
    searchList() {    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
    },
    async getrecordList() {
      const {data: res} = await this.$http.get('/tongkun/listDetail', {params: this.queryInfo});
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    async getTkPackageInfo() {
      const {data: res} = await this.$http.get('/tongkun/queryTkPackageInfo/'+this.queryInfo.id);
      this.tkPackageInfo = res.data;
    },
    toOrderDetail(row) {
      this.$router.push({
        name:'orderDetail',
        query:{
          id:row.id,
          isEdit:'0'
        }
      })
    },
    queryInfoClear() {    //清空
      this.queryInfo = {
        orderId: '',
        id: this.$route.query.id,
        trackingNumberCn: '',
        orderStatus: '',
        createTimeStart: '',
        createTimeEnd: '',
        sendTimeStart: '',
        sendTimeEnd: '',
        pageSize: 10,
        pageNum: 1,
      }
      // this.orderDateRangeValue = [];
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    // orderDateRangeValue(){
    //   //解决时间选择器清空后 绑定值为null问题
    //   if(!this.orderDateRangeValue){
    //     this.orderDateRangeValue = [];
    //     this.queryInfo.createTimeStart = '';
    //     this.queryInfo.createTimeEnd = '';
    //   }
    //   else{
    //     if(this.orderDateRangeValue.length>0){
    //       this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
    //       this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
    //     }
    //   }
    // }
  },
  created() {
    this.orderStatusOptions = [
      {
        value: '0',
        label: '等待到库'
      },
       {
        value: '1',
        label: '待购买'
      },
       {
        value: '2',
        label: '购买完'
      },
      {
        value: '4',
        label: '到库'
      },
      {
        value: '8',
        label: '检品中'
      },
      {
        value: '12',
        label: '检品完'
      },
      {
        value: '16',
        label: '仓库保管中'
      },
      {
        value: '20',
        label: '申请发货'
      },
      {
        value: '24',
        label: '不良待处理'
      },
      {
        value: '28',
        label: '换货待发回'
      },
      {
        value: '32',
        label: '换货等待到货'
      },
      {
        value: '36',
        label: '待部分退货'
      },
      {
        value: '40',
        label: '补发等待到货'
      },
      {
        value: '44',
        label: '待支付'
      },
      {
        value: '48',
        label: '待发送'
      },
      {
        value: '52',
        label: '已发送'
      },
      {
        value: '56',
        label: '已取消'
      },
      {
        value: '60',
        label: '退货申请中'
      },
      {
        value: '64',
        label: '退货待支付'
      },
      {
        value: '68',
        label: '待退货'
      },
      {
        value: '72',
        label: '已退货'
      },
      {
        value: '76',
        label: '销毁申请中'
      },
      {
        value: '80',
        label: '销毁待支付'
      },
      {
        value: '84',
        label: '已销毁'
      },
      {
        value: '88',
        label: '装箱中'
      },
    ];
    this.queryInfo.id = this.$route.query.id;
    this.getrecordList();
    this.getTkPackageInfo();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
.bill_top{
    width: 100%;
    height: 20px;
    margin: 10px;
    padding-right:15px ;
    padding-top: 15px;
    
}
.bill_top span{
    display: block;
    float: left;
    margin-left: 20px;
    
}
.bill_top i{
    text-decoration:underline;
    color: black;
}
.tk-title{
  color: #999999;
}
</style>